"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _timezoneMapping = _interopRequireDefault(require("@insided/shared/utils/timezoneUtils/timezoneMapping"));

var _timezoneUtils = require("@insided/shared/utils/timezoneUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Use a consistent default locale and handle SSR properly
var DEFAULT_LOCALE = 'en-US';

var getLocale = function getLocale() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  return navigator.language || DEFAULT_LOCALE;
};

var lang = getLocale();
var userLang = getLocale();

function formatStartAtForOverviewList(startAt) {
  var options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  var eventStartsAt = new Date(startAt * 1000);
  return eventStartsAt.toLocaleDateString(lang, options);
}

function formatStartAtForOverviewListCustomized(startAt) {
  var hour12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showTimezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var eventTimezone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var dateTimeOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: hour12
  };
  var timezoneOptions = eventTimezone ? {
    timeZone: eventTimezone
  } : {};

  var options = _objectSpread(_objectSpread({}, dateTimeOptions), timezoneOptions);

  var eventStartsAt = new Date(startAt * 1000);
  var timeZoneAbbr = (0, _timezoneUtils.getTimezoneAbbreviation)();
  var formattedTimeZone = eventTimezone ? (0, _timezoneUtils.formatDateInTimezone)(eventStartsAt, eventTimezone, 'z') : timeZoneAbbr;
  var timeString = eventStartsAt.toLocaleDateString(userLang, options);
  return "".concat(timeString).concat(showTimezone ? " (".concat(formattedTimeZone, ")") : '');
}

function isPastEvent(eventEndDate) {
  var currentDate = new Date();
  var endDate = new Date(eventEndDate * 1000);
  return currentDate > endDate;
}

function isEventPassed(endDate, endTime, timezone) {
  var currentTime = new Date();
  var eventTimeString = endTime === undefined || timezone === undefined ? '' : " ".concat(endTime.hours, ":").concat(endTime.minutes, " ").concat(endTime.period, " GMT").concat(timezone.offset);
  var eventEndTime = new Date("".concat(endDate).concat(eventTimeString));
  return currentTime > eventEndTime;
}

function formatDateForEventView(eventStartDate, eventEndDate, hour12, showTimeZone, eventTimezone) {
  var startDate = new Date(eventStartDate * 1000);
  var endDate = new Date(eventEndDate * 1000);
  var formattedTimeZone = eventTimezone ? (0, _timezoneUtils.formatDateInTimezone)(startDate, eventTimezone, 'z') : timeZone(startDate);
  var dateFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  };
  var timeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: hour12
  }; // set time and date to event's timezone

  var timezoneOptions = eventTimezone ? {
    timeZone: eventTimezone
  } : {};

  var timeOptions = _objectSpread(_objectSpread({}, timeFormatOptions), timezoneOptions);

  var dateTimeOptions = _objectSpread(_objectSpread(_objectSpread({}, dateFormatOptions), timeFormatOptions), timezoneOptions);

  var formattedStartDate = startDate.toLocaleDateString(userLang, dateTimeOptions);

  if (isSameDate(startDate, endDate)) {
    var formattedEndTime = endDate.toLocaleTimeString(userLang, timeOptions);
    return "".concat(formattedStartDate, " - ").concat(formattedEndTime).concat(showTimeZone ? " (".concat(formattedTimeZone, ")") : '');
  }

  var formattedEndDate = endDate.toLocaleDateString(userLang, dateTimeOptions);
  return "".concat(formattedStartDate, " - ").concat(formattedEndDate).concat(showTimeZone ? " (".concat(formattedTimeZone, ")") : '');
}

function isSameDate(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

function timeZone(startDate) {
  var _timeZoneMapping$time;

  var timeZoneFull = startDate.toTimeString().split('(')[1].slice(0, -1);
  return (_timeZoneMapping$time = _timezoneMapping.default[timeZoneFull]) !== null && _timeZoneMapping$time !== void 0 ? _timeZoneMapping$time : timeZoneFull;
}

function formatDateForGoogleCalenderLink(date) {
  return new Date(date * 1000).toISOString().replace(/-|:|\.\d\d\d/g, '');
}

function getTimeWithPeriod(date, hour12) {
  var dateParts = new Intl.DateTimeFormat(DEFAULT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: hour12 !== null && hour12 !== void 0 ? hour12 : true
  }).formatToParts(date);
  var hour = dateParts.find(function (part) {
    return part.type === 'hour';
  });
  var minute = dateParts.find(function (part) {
    return part.type === 'minute';
  });
  var dayPeriod = dateParts.find(function (part) {
    return part.type === 'dayPeriod';
  });
  return {
    hours: (hour === null || hour === void 0 ? void 0 : hour.value) === '00' ? '12' : hour === null || hour === void 0 ? void 0 : hour.value,
    minutes: minute === null || minute === void 0 ? void 0 : minute.value,
    period: dayPeriod === null || dayPeriod === void 0 ? void 0 : dayPeriod.value.toUpperCase()
  };
}

function convert12hourTo24hour(_ref) {
  var _ref$hours = _ref.hours,
      hours = _ref$hours === void 0 ? '' : _ref$hours,
      minutes = _ref.minutes,
      period = _ref.period;
  var convertedHours = hours === '12' && period === 'AM' ? '00' : hours;
  convertedHours = convertedHours !== '12' && period === 'PM' ? "".concat(Number(convertedHours) + 12) : convertedHours;
  convertedHours = convertedHours.length === 1 && +convertedHours < 10 ? "0".concat(convertedHours) : convertedHours;
  return "".concat(convertedHours, ":").concat(minutes);
}

function clearDateTimezone(date) {
  if (date === '') return undefined;
  var original = new Date(date);
  var userTimezoneOffset = -1 * original.getTimezoneOffset() * 60000;
  return new Date(original.getTime() - userTimezoneOffset);
}

function getFullUtcDate(date, time, timezone) {
  var _time$hours, _time$minutes, _time$period;

  if (!date) return '';
  var hours = (_time$hours = time.hours) !== null && _time$hours !== void 0 ? _time$hours : 0;
  var minutes = (_time$minutes = time.minutes) !== null && _time$minutes !== void 0 ? _time$minutes : 0;
  var period = (_time$period = time.period) !== null && _time$period !== void 0 ? _time$period : 'AM';
  var timezoneValue = timezone ? " ".concat(timezone.value) : '';
  return "".concat(date, " ").concat(hours, ":").concat(minutes, " ").concat(period).concat(timezoneValue);
}

var eventDateFormatter = {
  formatStartAtForOverviewList: formatStartAtForOverviewList,
  formatStartAtForOverviewListCustomized: formatStartAtForOverviewListCustomized,
  formatDateForEventView: formatDateForEventView,
  isPastEvent: isPastEvent,
  isEventPassed: isEventPassed,
  formatDateForGoogleCalenderLink: formatDateForGoogleCalenderLink,
  getTimeWithPeriod: getTimeWithPeriod,
  convert12hourTo24hour: convert12hourTo24hour,
  clearDateTimezone: clearDateTimezone,
  getFullUtcDate: getFullUtcDate,
  timeZone: timeZone
};
var _default = eventDateFormatter;
exports.default = _default;